import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import './LandmarkMarker.css';
import { Landmark } from '../types';

// Fix for default marker icons in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

interface LandmarkMarkerProps {
  landmark: Landmark;
  onClick: () => void;
}

const LandmarkMarker: React.FC<LandmarkMarkerProps> = ({ landmark, onClick }) => {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'wildlife':
        return '#4CAF50';
      case 'diving':
        return '#2196F3';
      case 'historical':
        return '#FF9800';
      case 'safety':
        return '#F44336';
      case 'camp':
        return '#9C27B0';
      default:
        return '#607D8B';
    }
  };

  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'wildlife':
        return '🐠';
      case 'diving':
        return '🤿';
      case 'historical':
        return '🏛️';
      case 'safety':
        return '⚠️';
      case 'camp':
        return '🏕️';
      default:
        return '📍';
    }
  };

  // Create custom icon
  const customIcon = L.divIcon({
    className: 'custom-marker',
    html: `
      <div class="marker-container" style="--marker-color: ${getCategoryColor(landmark.category)}">
        <div class="marker-icon">${getCategoryIcon(landmark.category)}</div>
        <div class="marker-pulse"></div>
      </div>
    `,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });

  return (
    <Marker
      position={[landmark.position.lat, landmark.position.lng]}
      icon={customIcon}
      eventHandlers={{
        click: onClick,
      }}
    >
      <Popup>
        <div className="marker-popup">
          <strong>{landmark.name}</strong>
          <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem' }}>
            Click for more information
          </p>
        </div>
      </Popup>
    </Marker>
  );
};

export default LandmarkMarker;
